import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    updateItemDisplayInfo,
    setItemWarnings
} from '../../../actions/items';
import { updateEditProductDetail } from '../../../actions/products'
import { scrollIntoView } from '../../../utills.js';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import Form from 'jd-library/Form';
import FormDate from 'jd-library/FormDate';
import ToggleBtnGroup from 'jd-library/ToggleBtnGroup';
import Dropdown from 'jd-library/Dropdown';
import { showToastMessage } from '../../../actions/toastmessage';
import style from './product-expiry.scss';

const ProductExpiry = (props) => {
    const [expiryBy, toggleExpiryBy] = useState(props.itemInfo.expiryBy || 'manufacturing_date');
    let bestBeforeRef = useRef(null);
    let dateOptions = [{
        label: 'Days',
        key: 'days'
    }, {
        label: 'Months',
        key: 'months'
    }, {
        label: 'Years',
        key: 'years'
    }];

    const updateInfoAndErrors = (key,value,err, warn) => {
        if(props.updateInfoAndErrors){
            props.updateInfoAndErrors(key,value,err,warn)
        }
        value!=null && !props.fromAddInventory && props.updateEditProductDetail([{ key,value }]);
        !props.fromAddInventory && props.setItemErrors({...props.errors, [key]: err });
        warn!=null && props.setItemWarnings({ [key]: warn});
    }

    const handleChange = (e, key) => {
        let tempVal = '';
        if (typeof(e.currentTarget.value) == "string" && !/^\d{0,5}$/.test(e.currentTarget.value)) {
            return;
        }
        else if (typeof(e.currentTarget.value) != "string"){
            tempVal = '' + e.currentTarget.value;
            if (!/^\d{0,5}$/.test(tempVal)){
                return;
            }
        }
        updateInfoAndErrors(key, e.currentTarget.value, "");
    }

    const validate = (value, formattedDate, activeTab, from) => {
        const currentDate = new Date();
        if(value){
            currentDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds())
            //Ignore time param while comparing two dates.
        }
        let dateTab = activeTab || expiryBy;
        let errorMsg = "";
        let warnMsg = '';
        if (dateTab == "expiry_date") {
            props.updateItemDisplayInfo({formattedExpDate: formattedDate});
            if (currentDate.getDate() == value.getDate() && currentDate.getMonth() == value.getMonth() && currentDate.getFullYear() == value.getFullYear() && (formattedDate && !formattedDate.includes("Y"))) {
                warnMsg = "Please note that the product will expire today";
                errorMsg = warnMsg;
            }
            else if (value.getDate && isNaN(value.getDate()) && (formattedDate && !formattedDate.includes("Y"))) {
                errorMsg = "Please Enter Valid Date";
            }
            updateInfoAndErrors('expiry_date', formattedDate, errorMsg, warnMsg);
        }
        if (dateTab == "manufacturing_date") {
            props.updateItemDisplayInfo({formattedManufDate: formattedDate});
            if (currentDate < value && (formattedDate && !formattedDate.includes("Y"))) {
                warnMsg = "You have Entered Future Date as Manufacturing Date";
                errorMsg = warnMsg;
            }
            else if (value.getDate && isNaN(value.getDate()) && (formattedDate && !formattedDate.includes("Y"))) {
                errorMsg = "Please Enter Valid Date";
            }
            updateInfoAndErrors('manufacturing_date', formattedDate, errorMsg, warnMsg);
            if(props.itemInfo.best_before && (value == "" || !value)){
                validateBestBeforeDate({warnMsg: warnMsg, currentManufacturingDate: '', errorMsg: errorMsg,date: formattedDate});
            } 
            else if(props.itemInfo.best_before)
            {
                validateBestBeforeDate({warnMsg: warnMsg, currentManufacturingDate: value,date: formattedDate});
            }
        }
    }
    const getDateObj = (dateString) => {
        if(dateString)
        {
            var dateParts = dateString.split('/');
            // month is 0-based, that's why we need dataParts[1] - 1
            var dateObj = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            return(dateObj);
        }
    }
    const validateBestBeforeDate = (params={}) => {
        let {unit, warnMsg, currentManufacturingDate, errorMsg,date} = params;
        var bestBeforeInDays = Number(props.itemInfo.best_before);
        var currentDate = new Date();
        var warningMsg = warnMsg || '';
        var bestBeforeUnit = unit || props.itemInfo.bestBeforeUnit || 'months';
        if(bestBeforeUnit == 'months'){
            bestBeforeInDays = bestBeforeInDays * 30;
        }else if(bestBeforeUnit == 'years'){
            bestBeforeInDays = bestBeforeInDays * 365;
        }

        if(props.itemInfo.manufacturing_date || currentManufacturingDate){
            var manufDateObj = getDateObj(props.itemInfo.manufacturing_date);
            if(currentManufacturingDate){
                manufDateObj = currentManufacturingDate;
            }

            var expDateByBestBefore = new Date();
            expDateByBestBefore.setTime( manufDateObj.getTime() + bestBeforeInDays * 86400000 );
            if(currentDate.getDate()==expDateByBestBefore.getDate() && currentDate.getMonth()==expDateByBestBefore.getMonth() && currentDate.getFullYear()==expDateByBestBefore.getFullYear()){
                warningMsg = "Warning: Please note that the product will expire today.";
            }else if(currentDate < manufDateObj && (manufDateObj && !props.itemInfo.manufacturing_date.includes("Y"))){
                warningMsg = "You have Entered Future Date as Manufacturing Date";
            }
            
            if(errorMsg){
                warningMsg = '';
                updateInfoAndErrors('manufacturing_date', typeof currentManufacturingDate === 'string' && currentManufacturingDate?.includes('/')?currentManufacturingDate:date, errorMsg, '');
            }


        } else if(bestBeforeUnit && !currentManufacturingDate) {
            updateInfoAndErrors('manufacturing_date',null,"Please Enter Valid Date",null);
        }

    }

    useEffect(() => {
        if(props.itemInfo[expiryBy]){
            validate(getDateObj(props.itemInfo[expiryBy]), props.itemInfo[expiryBy], expiryBy);
        }
    }, [])

    useEffect(() => {
        updateInfoAndErrors('expiryBy',expiryBy)
    },[expiryBy])

    return (
        <div className={style['product-expiry-container']+" "+props?.holderClass}>
            <div className={style['toggle-container']}>
                <div className={style['expiryby-label']}>Product Expiry By</div>
                <ToggleBtnGroup
                    selectedValue={expiryBy}
                    onToggle={(e, value) => {
                        toggleExpiryBy(value);
                        if(props.updateInfoAndErrors){
                            props.updateInfoAndErrors('expiryBy',value)
                        }
                        if(value == 'manufacturing_date' && !props.itemInfo.manufacturing_date && props.itemInfo.best_before) {
                            updateInfoAndErrors('manufacturing_date', props.itemInfo.manufacturing_date, null, null);
                            validate(getDateObj(props.itemInfo.manufacturing_date), props.itemInfo.manufacturing_date, 'manufacturing_date', "toggle");
                        }
                        if(props.itemInfo.manufacturing_date && props.itemInfo.expiry_date){
                            validate(getDateObj(props.itemInfo[value]), props.itemInfo[value], value, "toggle");
                        }
                    }}
                >
                    <ToggleBtnGroup.Btn className={style['input-grp-btn']} value='manufacturing_date'>
                        Manufacturing Date
                    </ToggleBtnGroup.Btn>
                    <ToggleBtnGroup.Btn className={style['input-grp-btn']} value='expiry_date'>
                        Expiry Date
                    </ToggleBtnGroup.Btn>
                </ToggleBtnGroup>
            </div>
            <div className={style['expiry-date-container'] + (props.session.isReadOnly ? ' read-only-mode' : '')}>
                <Form>
                    <FormDate
                        label={expiryBy == 'manufacturing_date' ? 'Manufacturing Date' : 'Expiry Date'}
                        iconClass='icon-calendarNew'
                        onDateChange={(event, obj, formattedDate) => { 
                            if(formattedDate){
                                if(expiryBy == 'manufacturing_date' ) {
                                    updateInfoAndErrors('manufacturing_date', formattedDate, null, null);
                                } else {
                                    updateInfoAndErrors('expiry_date', formattedDate, null, null);
                                }
                            }else{
                                if(expiryBy == 'manufacturing_date' ) {
                                    updateInfoAndErrors('manufacturing_date', formattedDate, null, null);
                                } else {
                                    updateInfoAndErrors('expiry_date', formattedDate, null, null);
                                }
                                // updateInfoAndErrors('manufacturing_date', formattedDate, null, null);
                                // updateInfoAndErrors('expiry_date', formattedDate, null, null);
                            }
                            // updateInfoAndErrors('isApplicableExpDate', true, null, null);
                            validate(obj, formattedDate, expiryBy);
                        }}
                        dateformat='dd/mm/yyyy'
                        errorMessage={props.errors[expiryBy] || props.warnings[expiryBy]}
                        isMobile={props.deviceData.isMobile}
                        onBlur={(event,obj,date,isValid)=>{ if(!isValid && props.deviceData.isMobile) updateInfoAndErrors(expiryBy, null, "Please Enter Valid Date", null, null)}}
                        variant='withMovingLabel'
                        warning={props.warnings[expiryBy]}
                        startDate={props.itemInfo[expiryBy] ? getDateObj(props.itemInfo[expiryBy]) : '' }
                        crossIcon={props.itemInfo[expiryBy] ? true : false}
                    ></FormDate>
                </Form>
            </div>
            {expiryBy == 'expiry_date' ? null :
                <div className={style['best-before-container']}>
                    <InputWithMovingLabel
                        value={props.itemInfo.best_before}
                        ref={bestBeforeRef}
                        label='Best Before'
                        holderClass={style['best-before-input'] + props.session.isReadOnly ? ' read-only-mode' : '' }
                        errorMessage={props.errors.best_before}
                        input={{
                            value: props.itemInfo.best_before || '',
                            onFocus: (e) => {
                                e.currentTarget && scrollIntoView(e.currentTarget,'add-edit-product');
                            },
                            onChange: e => { handleChange(e, 'best_before') },
                            onBlur: e => {
                                if (!e.currentTarget.value) {
                                    if(props.itemInfo.manufacturing_date)
                                        updateInfoAndErrors('best_before',null,"Please Enter Best Before",null);
                                }else if(props.itemInfo.manufacturing_date){
                                    validateBestBeforeDate({date: props.itemInfo.manufacturing_date});
                                }
                            },
                            type: props.deviceData.isIPhone ? 'number' : 'tel'
                        }}
                    />
                    <Dropdown
                        className={`${style['dropdown-div']} ${props.deviceData.isMobile ? style['dropdown-div-mobile'] : ''}
                            ${props.session.isReadOnly ? 'dropdown-div-read-only-mode' : ''}`}
                        optionList={dateOptions}
                        onChange={(e, value) => {
                            updateInfoAndErrors('bestBeforeUnit', e.key, null, null);
                            if(props.itemInfo.best_before)
                                validateBestBeforeDate({unit: e.key,date: props.itemInfo?.manufacturing_date});
                        }}
                        placeholder='Select Period'
                        label='Select Period'
                        value={props.itemInfo.bestBeforeUnit || 'months'}
                        scrollBarProps={{
                            autoHide: false
                        }}
                        openTop={props.openTop}
                    ></Dropdown>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state, props) => {
    return {
        session: state.session,
        deviceData: state.deviceData,
        itemInfo: props.itemInfo || state.products.editProduct,
        warnings: state.items.warnings,
        ...props
    };
};
export default connect(mapStateToProps, {
    updateEditProductDetail,
    updateItemDisplayInfo,
    setItemWarnings,
    showToastMessage
})(ProductExpiry);